import { SET_TENANT_BRANDING, SET_TENANT_DOMAIN_TYPE, SET_TENANT_NAME } from '../actions';

const initialState = {
  domainType: null,
  name: null,
  branding: null,
};

const tenant = function (state = initialState, action) {
  switch (action.type) {
    case SET_TENANT_DOMAIN_TYPE: {
      return { ...state, domainType: action.payload };
    }

    case SET_TENANT_NAME: {
      return { ...state, name: action.payload };
    }

    case SET_TENANT_BRANDING: {
      return { ...state, branding: action.payload };
    }

    default: {
      return state;
    }
  }
};

export default tenant;
